/**
 * The dev fixture the next Run asks the server to replay instead of calling the model, and how
 * fast: `slow` stretches every streaming state so a running card can be opened and inspected.
 *
 * Module state rather than a store: this is a dev-only escape hatch read once inside
 * `sendToModel`, and putting it in a store would put a development concern into the app's real
 * state. It is only ever set by `useDevTestData`, which no-ops in production.
 */
export type DevFixtureSpeed = "normal" | "slow";

let pendingFixture: { key: string; speed: DevFixtureSpeed } | null = null;

export function setPendingFixture(fixture: { key: string; speed: DevFixtureSpeed } | null): void {
  pendingFixture = fixture;
}

/** The active fixture key and speed, or null. Stays set so repeated Runs replay it. */
export function getPendingFixture(): { key: string; speed: DevFixtureSpeed } | null {
  return process.env.NODE_ENV === "production" ? null : pendingFixture;
}
